import PropertyBidCard from "@/Components/PropertyBigCard"
import { useAppSelector } from "@/store/hooks"
import { allPieces } from "@/utils/data"
import { mapDesigns } from "@mono/mapDesigns"

export const PrivateBuyNotification: React.FC<PrivateBuyNotificationProps> = ({
  propertyOrder,
  playerOrder,
}) => {
  const myGame = useAppSelector((state) => state.global.myGame)
  const myGameSituation = useAppSelector((state) => state.global.myGame?.situation)
  const myGamePlayers = useAppSelector((state) => state.global.myGame?.players)
  const myGameSettings = useAppSelector((state) => state.global.myGame?.settings)

  const winnerId = myGameSituation?.players.find(
    (player) => player.order === playerOrder
  )?.id
  const user = myGamePlayers?.find((user) => user.email === winnerId)
  const player = myGameSituation?.players.find(
    (player) => player.order === playerOrder
  ) as IPlayer
  const piece = allPieces.find((item) => item.id === player.pieceId)
  const myMap = mapDesigns.find(
    (map) => map.id === myGameSettings?.mapId
  )
  const cell = myMap?.cells.find((cell) => cell.order === propertyOrder)
  // const propertywon = getcellbymapidandorder(
  //   state.mygame?.settings.mapid as string,
  //   propertyorder
  // )
  return (
    <>
      <div
        data-testid="notification.private-buy"
        className="fixed top-1/2 left-1/4 z-[100] -translate-y-1/2 -translate-x-full auction-won-card-pop-out"
      >
        <PropertyBidCard cell={cell as ICell}></PropertyBidCard>
      </div>
      <div className="fixed top-1/2 items-center gap-5 -translate-y-1/2 w-full py-10 font-semibold shadow-centerCardGlow border-auction-activeBorderColor border-t-4 border-b-4 flex justify-center text-5xl z-20 text-white font-poppins bg-[rgba(0,0,0,0.8)] auction-won-banner-pop-out">
        privately bought by
        <div className="flex items-center gap-4">
          <img src={piece?.imgSrc} className="h-11 w-11"></img>
          <div className="flex flex-col gap-2">
            <div className="">{user?.username}</div>
          </div>
        </div>
      </div>
    </>
  )
}
